module.exports = __webpack_public_path__ + "img/points-count.be9ed747.svg";